import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginOnTenant from './components/Login';
import Index from './components/Index';
import Dashboard from './components/Dashboard';
import ProtectedRouteTenant from './components/ProtectedRouteTenant.js';
import ProtectedRoute from './components/ProtectedRoute.js';
import Header from './components/Header';
import Footer from './components/Footer';
import EventDetailsV2 from './components/EventDetailsV2'; // Import the new EventDetailsV2 component
import './App.css';
import EventDetails from './components/EventDetails';
import { EventProvider } from './contexts/EventContext';
import { UserProvider, useUser } from './contexts/UserContext'; // Changed: Import useUser instead of UserContext
import { TenantProvider, useTenant } from './contexts/TenantContext'; // Import TenantProvider and useTenant
import UserProfile from './components/UserProfile';
import i18n from './i18n';
import { ThemeProvider } from '@mui/material/styles';
// import theme from './theme/index.ts'; // Old import
import createCustomTheme, { defaultMuiTheme } from './theme/index.ts'; // Import the function and default theme
import OidcCallbackTenant from './components/OidcCallbackTenant.js'; // <-- Ajoutez cet import en haut
import OidcCallbackCommon from './components/OidcCallbackCommon.js'; // Import common OIDC callback
import SamlCallback from './components/SamlCallback';
import TenantSaS from './components/TenantSaS'; // Import TenantSaS component
import { GoogleOAuthProvider } from '@react-oauth/google';


function AppInternal() {
  const { userData } = useUser();
  const { tenantData } = useTenant(); // Get tenantData

  useEffect(() => {
    if (userData && userData.language && i18n.language !== userData.language) {
      i18n.changeLanguage(userData.language);
    }
  }, [userData]);

  // Create the theme based on tenantData or use the default
  const activeTheme = tenantData?.metadatas ? createCustomTheme(tenantData.metadatas) : defaultMuiTheme;

  return (
    <ThemeProvider theme={activeTheme}> {/* Use the dynamically created theme */}
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || '375155993689-ehug6p01pbnl80qo8dj6edps7p0qino6.apps.googleusercontent.com'}>
        <Router>
          <div className="App">
            <Header />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/app/:tenant_id/login" element={<LoginOnTenant />} />
              <Route 
                path="/app/:tenant_id/dashboard" 
                element={
                  <ProtectedRouteTenant>
                    <Dashboard />
                  </ProtectedRouteTenant>
                } 
              />
              <Route 
                path="/app/:tenant_id/events/:event_id" 
                element={
                  <ProtectedRouteTenant>
                    <EventDetailsV2 />
                  </ProtectedRouteTenant>
                }
              />
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <UserProfile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/sas" 
                element={
                  <ProtectedRoute>
                    <TenantSaS />
                  </ProtectedRoute>
                } 
              />
              
              <Route path="/app/:tenant_id/event/:event_id/:task_id" element={<EventDetails />} />
              <Route path="/oidc/callback" element={<OidcCallbackTenant />} /> {/* <-- Ajoutez cette ligne */}
              <Route path="//oidc/common/callback" element={<OidcCallbackCommon />} />
              <Route path="/saml/callback" element={<SamlCallback />} /> {/* Add SAML callback route */}
              <Route path="/app/:tenant_id/" element={<Navigate to="/app/:tenant_id/dashboard" />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </GoogleOAuthProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <UserProvider>
      <TenantProvider>
        <EventProvider>
          <AppInternal />
        </EventProvider>
      </TenantProvider>
    </UserProvider>
  );
}

export default App;
